import '../../utils/index.mjs';
import TreeSelect from './src/tree-select.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTreeSelect = withInstall(TreeSelect);

export { ElTreeSelect, ElTreeSelect as default };
//# sourceMappingURL=index.mjs.map
